import React, { useState } from "react";

import { Button } from "./button";
import { Input } from "./input";
import { Label } from "./label";
import { Textarea } from "./textarea";
import { cn } from "../../lib/utils";

export const Contact2 = ({
  title = "Un projet en tête ?",
  description = "Écrivez-moi : je reviens vers vous rapidement avec une proposition claire et adaptée.",
}) => {
  const [result, setResult] = useState("");

  const onSubmit = async (event) => {
    event.preventDefault();
    const formData = new FormData(event.target);

    const first = formData.get("firstname") || "";
    const last = formData.get("lastname") || "";
    if (!formData.get("name")) {
      formData.append("name", `${first} ${last}`.trim());
    }

    formData.append("access_key", "6c36fe49-b242-42fb-b0e9-3d758622f689");

    try {
      const response = await fetch("https://api.web3forms.com/submit", {
        method: "POST",
        body: formData,
      });

      const data = await response.json();
      if (data.success) {
        setResult("Message envoyé avec succès.");
        event.target.reset();
      } else {
        setResult("Une erreur est survenue, veuillez réessayer.");
      }
    } catch {
      setResult("Impossible d'envoyer le message pour le moment.");
    }
  };

  const field =
    "border-white/10 bg-white/[0.04] text-white placeholder:text-zinc-600 focus-visible:ring-brand/40 focus-visible:ring-offset-surface";

  return (
    <section
      className="relative w-full overflow-hidden bg-surface-raised py-24 md:py-32"
      id="contact"
    >
      <div className="pointer-events-none absolute inset-0 bg-grid-fine bg-grid opacity-25" aria-hidden />
      <div className="container relative mx-auto px-4 md:px-6">
        <div className="mx-auto flex max-w-5xl flex-col gap-10 lg:flex-row lg:items-start lg:gap-16">
          <div className="max-w-md lg:pt-4">
            <p className="text-xs font-semibold uppercase tracking-[0.3em] text-brand">Contact</p>
            <h2 className="mt-4 font-display text-3xl font-bold tracking-tight text-white md:text-5xl">
              {title}
            </h2>
            <p className="mt-4 text-lg text-zinc-500">{description}</p>
            <p className="mt-8 text-sm text-zinc-600">
              Réponse sous 24–48h ouvrées. Aucun spam, uniquement l’essentiel pour avancer.
            </p>
          </div>

          <form
            onSubmit={onSubmit}
            className="w-full max-w-xl flex-1 rounded-2xl border border-white/[0.08] bg-surface-card p-5 shadow-card sm:p-6 md:p-10"
          >
            <div className="flex flex-col gap-4 md:flex-row">
              <div className="grid w-full flex-1 items-center gap-2">
                <Label htmlFor="firstname" className="text-zinc-400">
                  Prénom
                </Label>
                <Input
                  type="text"
                  id="firstname"
                  name="firstname"
                  placeholder="Votre prénom"
                  required
                  className={cn(field)}
                />
              </div>
              <div className="grid w-full flex-1 items-center gap-2">
                <Label htmlFor="lastname" className="text-zinc-400">
                  Nom
                </Label>
                <Input
                  type="text"
                  id="lastname"
                  name="lastname"
                  placeholder="Votre nom"
                  required
                  className={cn(field)}
                />
              </div>
            </div>
            <div className="mt-5 grid w-full gap-2">
              <Label htmlFor="email" className="text-zinc-400">
                Email
              </Label>
              <Input
                type="email"
                id="email"
                name="email"
                placeholder="vous@exemple.com"
                required
                className={cn(field)}
              />
            </div>
            <div className="mt-5 grid w-full gap-2">
              <Label htmlFor="subject" className="text-zinc-400">
                Sujet
              </Label>
              <Input
                type="text"
                id="subject"
                name="subject"
                placeholder="Ex. : site vitrine, refonte, SEO…"
                required
                className={cn(field)}
              />
            </div>
            <div className="mt-5 grid w-full gap-2">
              <Label htmlFor="message" className="text-zinc-400">
                Message
              </Label>
              <Textarea
                placeholder="Décrivez votre besoin, vos délais, vos liens utiles…"
                id="message"
                name="message"
                required
                className={cn(
                  "min-h-[140px] rounded-md border px-3 py-2 text-sm focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2",
                  field
                )}
              />
            </div>
            <Button
              type="submit"
              className="mt-8 h-12 w-full rounded-xl bg-brand text-base font-semibold text-surface shadow-glow hover:bg-brand-bright"
            >
              Envoyer le message
            </Button>
            {result ? (
              <p className="mt-4 text-center text-sm text-brand">{result}</p>
            ) : null}
          </form>
        </div>
      </div>
    </section>
  );
};
